import React from "react";
import { useRoutes } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import {baseTheme} from './assets/global/Theme-variable'
import Themeroutes from "./routes/routers";

import './App.css';

const App = () => {
  const routing = useRoutes(Themeroutes);
  

  return (
    <ThemeProvider theme={baseTheme}>
      {routing}
    </ThemeProvider>
  );
};

export default App;
